import { SanityBusinessHours, SanitySmProduct } from '../services/sanity/types'

export const getBusinessHours = (products: SanitySmProduct[]) => {
  let buildingBusinessHours: SanityBusinessHours = { startHour: '09:00', endHour: '17:00' }

  if (products[0]?.buildingBusinessHours) {
    buildingBusinessHours =
      Number(products[0]?.buildingBusinessHours?.startHour?.split(':')[0]) <
      Number(products[0]?.buildingBusinessHours?.endHour?.split(':')[0])
        ? {
            startHour: products[0].buildingBusinessHours.startHour,
            endHour: products[0].buildingBusinessHours.endHour,
          }
        : { startHour: '09:00', endHour: '17:00' }
  }

  const spacesWithBusinessHours = products.filter(
    (product) =>
      product.spaceBusinessHours && !!product.spaceBusinessHours?.startHour && !!product.spaceBusinessHours?.endHour
  )

  if (spacesWithBusinessHours.length > 0) {
    const earliestSpaceStartHour = spacesWithBusinessHours.reduce(
      (min, product) =>
        timeToNumber(product.spaceBusinessHours!.startHour) < timeToNumber(min)
          ? product.spaceBusinessHours!.startHour
          : min,
      spacesWithBusinessHours[0].spaceBusinessHours!.startHour
    )
    const latestSpaceEndHour = spacesWithBusinessHours.reduce(
      (max, product) =>
        timeToNumber(product.spaceBusinessHours!.endHour) > timeToNumber(max)
          ? product.spaceBusinessHours!.endHour
          : max,
      spacesWithBusinessHours[0].spaceBusinessHours!.endHour
    )
    const startHour =
      timeToNumber(buildingBusinessHours.startHour) <= timeToNumber(earliestSpaceStartHour)
        ? buildingBusinessHours.startHour
        : earliestSpaceStartHour
    const endHour =
      timeToNumber(buildingBusinessHours.endHour) >= timeToNumber(latestSpaceEndHour)
        ? buildingBusinessHours.endHour
        : latestSpaceEndHour
    return { startHour, endHour }
  }

  return { ...buildingBusinessHours }
}

const timeToNumber = (time: string) => {
  const [hour, minutes] = time.split(':').map((s) => parseInt(s, 10))
  return hour + minutes / 60
}
